/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EClassType } from "../types/EClassType.ts";

/**
 * @description 1 = Normal | 2 = OnDemand |
 */
export const eClassTypeSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe("1 = Normal | 2 = OnDemand | ") as unknown as ToZod<EClassType>;
